<script>
import {mapState} from 'vuex';

import FormField from 'components/FormField';
import axios from "axios";
import config from "config";

export default {
    components: {
        FormField,
    },
    data: () => ({
        loading: false,
    }),
    created() {
        axios.get(`${config.API_URL}csrf-cookie`, {'withCredentials': true});
    },
    computed: {
        ...mapState({
            login: state => state.account.login,
            email: state => state.account.login.email,
            password: state => state.account.login.password,
        }),
    },
    methods: {
        async handleSubmit() {
            this.loading = true;

            try {
                await this.$store.dispatch('login');
                this.loading = false;
            } catch (e) {
                this.loading = false;
            }
        },
    },
};
</script>

<template lang='pug'>
    .mx-auto.w-11-12.lg_w-1-2.xxl_w-5-12.my-2.lg_my-4

        //- .text-lg.lg_text-2xl.dark-mode_text-secondary-200.text-secondary.text-center.block Don't have an account? #[router-link.text-primary(:to='{ name: "register" }') Sign Up]

        observe(v-slot='{ passes }')
            form(@submit.prevent='passes(handleSubmit)')
                form-field(
                    label='Email',
                    rules='required|email',
                    :value='email',
                    @input='updateState(login, "email", $event)',
                )

                form-field(
                    password-reveal,
                    type='password',
                    label='Password',
                    rules='required|min:6',
                    :value='password',
                    @input='updateState(login, "password", $event)',
                )

                b-button.mt-1(
                    outlined,
                    expanded,
                    size='is-medium',
                    type='is-primary',
                    native-type='submit',
                    :loading='loading',
                    :disabled='loading',
                ) Sign in

        //- .flex.justify-center
          a.lg_text-lg.text-primary.mt-1.inline-block(href='/') Forgot Password?
</template>

<style>
</style>
